import React from "react";

const PrivacyPolicy = () => {
  const sections = [
    {
      title: "1. Information We Collect",
      content:
        "We collect your name and phone number to personalize your experience and manage your account. No other personal data is collected.",
    },
    {
      title: "2. Images and Camera Access",
      content:
        "IOU Hub may request access to your camera to upload images of items and payment receipts. Images are only stored if you choose to upload them.",
    },
    {
      title: "3. How We Use Your Information",
      content:
        "We use your information to manage your account, enhance your experience, and allow debt tracking functionality. We do not sell or share your data with third parties.",
    },
    {
      title: "4. Data Storage and Security",
      content:
        "Your data is stored securely with encryption and access controls. We take all reasonable precautions to protect your information. On account deletion, all personal data is deleted from our servers.",
    },
    {
      title: "5. Your Data Rights",
      content:
        "You can delete your account and all associated data at: https://iou-hub-9d38f.web.app/delete-account",
    },
    {
      title: "6. Children's Privacy",
      content:
        "This app is not intended for children under 13. We do not knowingly collect data from children.",
    },
    {
      title: "7. Policy Updates",
      content:
        "We may update this policy. Continued use of the app means you accept any changes.",
    },
    {
      title: "8. Contact Us",
      content:
        "If you have any questions or concerns, please contact us at sunal.fontinelle@gmail.com",
    },
  ];

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>IOU Hub Privacy Policy</h1>
          <p style={styles.date}>Effective Date: 19th April 2025</p>
        </div>

        <div style={styles.content}>
          {sections.map((section, index) => (
            <div key={index} style={styles.section}>
              <h2 style={styles.sectionTitle}>{section.title}</h2>
              <p style={styles.text}>{section.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    height: "100vh",
    overflowY: "auto",
    backgroundColor: "#f5f5f5",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "40px 20px",
    backgroundColor: "#FACC15",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    lineHeight: 1.6,
    minHeight: "100%",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
    paddingBottom: "20px",
    borderBottom: "1px solid #eee",
  },
  title: {
    fontSize: "32px",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: "0 0 10px 0",
    letterSpacing: "-0.5px",
  },
  date: {
    fontSize: "16px",
    color: "#666",
    margin: 0,
  },
  content: {
    maxWidth: "700px",
    margin: "0 auto",
  },
  section: {
    marginBottom: "32px",
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "#f8f9fa",
    transition: "background-color 0.2s ease",
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#1a1a1a",
    margin: "0 0 12px 0",
  },
  text: {
    fontSize: "16px",
    color: "#333",
    margin: 0,
    lineHeight: 1.7,
  },
};

export default PrivacyPolicy;
